var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from "react";
import { useForm } from "react-hook-form";
import { REJECTION_CODES_TEXT } from "../../../constants/rejectionCodes.constants";
var DEFAULT_VALUES = { name: "", shortCode: "" };
var draftCodeIdSequence = 0;
var nextDraftCodeId = function () {
    draftCodeIdSequence += 1;
    return "draft-code-".concat(Date.now(), "-").concat(draftCodeIdSequence);
};
var buildDraftCode = function (values) { return ({
    id: nextDraftCodeId(),
    code: values.code.trim() || null,
    label: values.label.trim() || null,
    transaction: values.transaction,
    description: values.description.trim(),
    action: values.action.trim() || null,
    actionDescription: values.actionDescription.trim() || null,
    cancellationReasonId: null,
}); };
export var useNewSetModal = function (props) {
    var _a = useState([]), draftCodes = _a[0], setDraftCodes = _a[1];
    var _b = useState(), draftError = _b[0], setDraftError = _b[1];
    var _c = useForm({
        mode: "onTouched",
        defaultValues: DEFAULT_VALUES,
    }), control = _c.control, handleSubmit = _c.handleSubmit, reset = _c.reset;
    var onAddDraftCode = function (values) {
        setDraftCodes(function (prev) { return __spreadArray(__spreadArray([], prev, true), [buildDraftCode(values)], false); });
        setDraftError(undefined);
    };
    var onRemoveDraftCode = function (codeId) {
        setDraftCodes(function (prev) { return prev.filter(function (code) { return code.id !== codeId; }); });
    };
    var onSubmit = handleSubmit(function (values) {
        if (draftCodes.length === 0) {
            setDraftError(REJECTION_CODES_TEXT.newSetDraftError);
            return;
        }
        props.onCreate(values, draftCodes);
        reset(DEFAULT_VALUES);
        setDraftCodes([]);
        setDraftError(undefined);
    });
    var onCancel = function () {
        reset(DEFAULT_VALUES);
        setDraftCodes([]);
        setDraftError(undefined);
        props.onClose();
    };
    return {
        control: control,
        onSubmit: onSubmit,
        onCancel: onCancel,
        draftCodes: draftCodes,
        onAddDraftCode: onAddDraftCode,
        onRemoveDraftCode: onRemoveDraftCode,
        draftError: draftError,
    };
};
